import { ObservableFromFetch } from "./ObservableFromFetch"

export const saveConsent = (testEventId: number, consentId: number) => ObservableFromFetch<void>(`Results/UpdateConsent?testEventId=${testEventId}&consentId=${consentId}`, undefined, "post")
